import {useEffect} from "react";
import CryptoJS from "crypto-js";

/**
 * message pang intro page
 * https://www.bizting.co.kr/hosting/message-pang/intro
 * */
const HostingMessagePangIntro = () => {
    useEffect(() => {
        window.sessionStorage.setItem('adSrc', 'eyAiYWRQYXRoIiA6ICAiTUVTU0FHRV9QQU5HIn0=');

        const state = {
            hostType: 'MP',
        };

        let encryptedState = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(state), process.env.REACT_APP_AES_ENCRYPT_KEY).toString());

        let url = `${window.location.origin}/event`;
        url += `?ad_src=${encodeURIComponent('eyAiYWRQYXRoIiA6ICAiTUVTU0FHRV9QQU5HIn0=')}`;
        url += `&state=${encryptedState}`;

        window.location.href = url;
    });
};

export default HostingMessagePangIntro;
